<form class="needs-validation" [formGroup]="form" novalidate>

    <div class="row">
        <div class="col-md-4">

            <div class="card card-accent-success animated fadeIn">

                <div class="card-header-buscador">
                    <i class="fa fa-plus"></i> <strong id="stAduana">Aduanas</strong>
                    <label class="col-form-label required-field" for="stAduana"></label>
                </div>
                <div class="card-body-detalle-list">

                    <div class="row">
                        <div class="col-md-12">

                            <div class="form-group">
                                <div class="input-group">

                                    <input name="Descripcion" title="" class="form-control" id="inpDescripcion" type="text" formControlName="Aduana" [ngClass]="displayFieldCssNoSubmit('Aduana')">

                                    <span class="input-group-btn">
                                        &nbsp;<button name="btnAddAduana" class="btn btn-list btn-secondary" type="button" title="Añade una Aduana" (click)="onAddAduana()"><i class="fa fa-plus"></i></button>
                                    </span>

                                    <div class="invalid-feedback" *ngIf="isFieldInvalidNoSubmit('Aduana','required')">
                                        Debe especificar una Aduana.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">

                        <div *ngIf="puntoInspeccion" class="col-md-12">

                            <table class="table table-list table-responsive table-sm">
                                <tbody>
                                    <tr *ngFor="let item of puntoInspeccion.TAduanaCollection">
                                        <td scope="col">
                                            <div class="btn-group">

                                                <button (click)="onDeleteAduana(item)"
                                                        class="btn btn-sm btn-danger">
                                                    <i class="fa fa-remove"></i>

                                                </button>
                                            </div>
                                        </td>

                                        <td scope="col" class="td-list">{{item.Descripcion}}</td>
                                    </tr>

                                </tbody>
                            </table>
                            <!--</div>

                            </div>-->
                        </div>
                    </div>

                </div>
            </div>

        </div>

        <div class="col-md-4">

            <div class="card card-accent-success animated fadeIn">
                <div class="card-header-buscador">
                    <i class="fa fa-plus"></i> <strong id="stAduana">Ubicaciones</strong>
                    <!--<label class="col-form-label" for="stAduana" [ngClass]="{ 'required-field' : isEspania() }"></label>-->
                </div>
                <div class="card-body-detalle-list">



                    <div class="row">

                        <div *ngIf="puntoInspeccion" class="col-md-12">

                            <table style="margin-top: 0px;" class="table table-list table-responsive table-sm">
                                <thead>
                                    <tr>
                                        <!-- Columna vacía -->
                                        <th scope="col"></th>
                                        <!-- Columna Descripción -->
                                        <th scope="col" style="width:80%">Descripción</th>
                                        <!-- Columna 'Por Defecto' -->
                                        <th scope="col">Por Defecto</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr *ngFor="let item of puntoInspeccion.TUbicacionCollection">
                                        <!-- Columna vacía para los botones u otros elementos -->
                                        <td scope="col">
                                            <div class="btn-group">
                                                <!--<button (click)="onDeleteUbicacion(item)"
                            class="btn btn-sm btn-danger">
                            <span class="fa fa-remove"></span>
                        </button>-->
                                            </div>
                                        </td>

                                        <!-- Columna Descripción -->
                                        <td scope="col" class="td-list" style="width:80%">{{item.Descripcion}}</td>

                                        <!-- Columna 'Por Defecto' con el pipe 'siNo' -->
                                        <td scope="col" class="td-list">{{item.PorDefecto | siNo}}</td>
                                    </tr>
                                </tbody>
                            </table>




                        </div>
                    </div>



                </div>
            </div>

        </div>

        <div class="col-md-4">


            <div class="card card-accent-success animated fadeIn">
                <div class="card-header-buscador">
                    <i class="fa fa-plus"></i> <strong id="stAduana">Hora inspección</strong>
                </div>
                <div class="card-body-detalle-list">

                    <div class="row">
                        <div class="col-md-12" style="display: flex;">
                            <div class="form-group form-group-float-right">
                                <div class="input-group">

                                    <!--<ngb-timepicker formControlName="HoraIntervalo"></ngb-timepicker>@adua 16:09:2021 daba error con Ang12-->

                                    <p-calendar [timeOnly]="true" formControlName="HoraIntervalo"></p-calendar>

                                    <span class="input-group-btn margin-calendar">
                                        &nbsp;<button name="btnAddIntervalo" class="btn btn-list btn-timepicker btn-secondary" type="button"
                                                      title="Añade un Intervalo" (click)="onAddIntervalo()">
                                            <i class="fa fa-plus"></i>
                                        </button>
                                    </span>
                                </div>

                            </div>
                        </div>

                    </div>

                    <div class="row">

                        <div *ngIf="puntoInspeccion" class="col-md-12">


                            <table class="table table-list table-responsive table-sm">

                                <tbody>
                                    <tr *ngFor="let item of puntoInspeccion.TIntervaloHoraPuntoInspeccionCollection">

                                        <td scope="col">
                                            <div class="btn-group">

                                                <button (click)="onDeleteIntervalo(item)"
                                                        class="btn btn-sm btn-danger">
                                                    <span class="fa fa-remove"></span>

                                                </button>
                                            </div>
                                        </td>

                                        <td scope="col" class="td-list">{{item.HoraInicio}}</td>
                                    </tr>

                                </tbody>
                            </table>

                        </div>
                    </div>



                </div>
            </div>

        </div>

    </div>

</form>
